import React from "react";
import {Navigate, useLocation} from "react-router-dom";

export default ({user, children,}) => {
    const {pathname}=useLocation()
    if (!user) {
        return <Navigate to={"/profile/login"} state={{next:pathname}}/>;
    }
    return children;
};



